<template>
  <div>
    <!-- Navbar -->
    <NavbarComponent v-if="showNavbar" />
    <musicaFondo v-if="showmusicaFondo" />

    <InvitadoEvento 
      v-if="showInvitadoEvento && isValidIdInvitado" 
      :id-invitado="Number(idInvitado)" 
      :nombre="nombreVariable" 
      :id-festejado="Number(idFestejado)" 
    />

    <fondocambiante v-if="showfondocambiente" />
    <BienvenidaPage v-if="showBienvenida" />
    <contador v-if="showcontador" />
    <dondeycuando v-if="showdondeycuando" />
    <padresevento v-if="showpadresevento" />
    <itinerario v-if="showitinerario" />
    <carrusel v-if="showcarrusel" />
    <codigovestimenta v-if="showcodigovestimenta" />
                <mensajeregalos v-if="showmensajeregalos" />

    <mesaRegalos v-if="showmesaRegalos" />
        <ImagenSegunda v-if="showimagensegunda" />

    <confirmacionasistencia
      v-if="showInvitadoEvento && isValidIdInvitado" 
      :id-invitado="Number(idInvitado)" 
      :nombre="nombreVariable" 
      :id-festejado="Number(idFestejado)" 
    />


    <quotemensaje v-if="showquotemensaje" />
        <imagenprimera v-if="showimagenprimera" />

    <carrusel2 v-if="showcarrusel2" />
    <blogevento
      v-if="showblogevento"
      :id-invitado="Number(idInvitado)" 
      :nombre="nombreVariable" 
      :id-festejado="Number(idFestejado)" 
    />
    <hashtagetiqueta  
      v-if="showInvitadoEvento && isValidIdInvitado" 
      :id-invitado="Number(idInvitado)" 
      :nombre="nombreVariable" 
      :id-festejado="Number(idFestejado)"  
    /> 

    <carrusel-componente-3 v-if="showcarrusel3" />
    <Ventanaemergente v-if="showventana" />
    <img_fixed v-if="showimg_fixed" />
  </div>
</template>

<script>
import { ref, onMounted, watch, computed } from 'vue';
import { useRoute } from 'vue-router';

import NavbarComponent from './narvar.vue';
import BienvenidaPage from './BienvenidaPage.vue';
import imagenprimera from './imagenprimera.vue';
import padresevento from './padresevento.vue';
import dondeycuando from './dondeycuando.vue';
import itinerario from './itinerario.vue';
import mensajeregalos from './mensajeregalos.vue';
import InvitadoEvento from './invitado_evento.vue';
import confirmacionasistencia from './confirmaciónasistencia.vue';
import blogevento from './blog_evento.vue';
import quotemensaje from './quotemensaje.vue';
import img_fixed from './img_fixed.vue';
import musicaFondo from './musica_fondo.vue';
import contador from './contador.vue';
import mesaRegalos from './regalos';
import codigovestimenta from './codigovestimenta.vue';
import carruselComponente3 from './carruselComponente-3.vue';
import hashtagetiqueta from './hashtag_etiqueta.vue';
import carrusel from './carruselComponent.vue';
import carrusel2 from './Carrusel-Component-2.vue';
import Ventanaemergente from './ventanaemergente.vue';
import fondocambiante from './fondocambiante.vue';
import ImagenSegunda from './imagenSegunda.vue';

export default {
  name: 'Componentep-v',
  components: {
    NavbarComponent,
    BienvenidaPage,
    ImagenSegunda,
    padresevento,
    imagenprimera,
    carrusel,
    dondeycuando,
    fondocambiante,
    itinerario,
    carrusel2,
    mensajeregalos,
    carruselComponente3,
    mesaRegalos,
    hashtagetiqueta,
    codigovestimenta,
    InvitadoEvento,
    confirmacionasistencia,
    quotemensaje,
    contador,
    blogevento,
    Ventanaemergente,
    img_fixed,
    musicaFondo,
  },
  setup() {
    const showNavbar = ref(false);
    const showBienvenida = ref(false);
    const showimagenprimera = ref(false);
    const showpadresevento = ref(false);
    const showdondeycuando = ref(false);
    const showitinerario = ref(false);
    const showmensajeregalos = ref(false);
    const showmesaRegalos = ref(false);
    const showimagensegunda=ref(false);
    const showInvitadoEvento = ref(false);
    const showfondocambiente = ref(false);
    const showconfirmacionasistencia = ref(false);
    const showcontador = ref(false);
    const showquotemensaje = ref(false);
    const showblogevento = ref(false);
    const showimg_fixed = ref(false);
    const showmusicaFondo = ref(false);
    const showventana = ref(false);
    const showcarrusel3 = ref(false);
    const showhashtag = ref(false);
    const showcarrusel = ref(false);
    const showcodigovestimenta = ref(false);
    const showcarrusel2 = ref(false);

    const route = useRoute();
    const idInvitado = ref(Number(route.params.idInvitado) || undefined);
    const idFestejado = ref(Number(route.params.idFestejado) || undefined);
    const nombreVariable = ref(route.params.nombre);

    const isValidIdInvitado = computed(() => !isNaN(idInvitado.value) && idInvitado.value !== undefined);
    const isValidFestejado = computed(() => !isNaN(idFestejado.value) && idFestejado.value !== undefined);

    watch(() => route.params.idInvitado, (newId) => {
      idInvitado.value = Number(newId);
    });
    watch(() => route.params.idFestejado, (newId) => {
      idFestejado.value = Number(newId);
    });
    watch(() => route.params.nombre, (newVal) => {
      nombreVariable.value = newVal;
    });

    const mostrarTodo = () => {
      showNavbar.value = true;
      showBienvenida.value = true;
      showimagenprimera.value = true;
      showpadresevento.value = true;
      showdondeycuando.value = true;
      showitinerario.value = true;
      showventana.value = true;
      showimagensegunda.value=true;
      showfondocambiente.value = true;
      showmensajeregalos.value = true;
      showmesaRegalos.value = true;
      showhashtag.value = true;
      showcarrusel.value = true;
      showInvitadoEvento.value = true;
      showconfirmacionasistencia.value = true;
      showquotemensaje.value = true;
      showblogevento.value = true;
      showcarrusel3.value = true;
      showcontador.value = true;
      showcarrusel2.value = true;
      showcodigovestimenta.value = true;
      showimg_fixed.value = true;
      showmusicaFondo.value = true;
    };

    // ✅ Al montar el componente, mostrar todo automáticamente
    onMounted(() => {
      mostrarTodo();
    });

    return {
      showNavbar,
      showBienvenida,
      showdondeycuando,
      showitinerario,
      showmensajeregalos,
      showInvitadoEvento,
      showfondocambiente,
      showconfirmacionasistencia,
      showcontador,
      showquotemensaje,
      showblogevento,
      showimg_fixed,
      showmusicaFondo,
      showcarrusel3,
      showhashtag,
      showcarrusel,
      showmesaRegalos,
      showcodigovestimenta,
      showcarrusel2,
      showimagensegunda,
      showimagenprimera,
      idInvitado,
      idFestejado,
      nombreVariable,
      isValidIdInvitado,
      isValidFestejado,
    };
  }
};
</script>

<style scoped>
/* Tus estilos aquí si lo necesitas */
</style>
